export const Bio = {
  name: "Vidhya Sagar",
  roles: [
    "Senior Linux Administrator",
    "Senior DevOps Engineer ",
    "AWS Specialist",
    "System Administrator",
    "Linux Systems Engineer"
  ],
  description:
    "Senior Linux System Admin | DevOps engineer with 6+ years of experience building secure, scalable infrastructure. Skilled in automation, CI/CD (Terraform, Docker, Kubernetes, Jenkins), and cloud (AWS, Hetzner). Focused on system reliability, monitoring, security, and cloud migration to drive efficient, resilient operations.",
  github: "https://github.com/vidhyasagar-go",
  resume:
    "https://docs.google.com/document/d/1iUyrysqVM_p1BBlvBapSv7YR5jHxGG1u/edit?usp=sharing&ouid=112282152930796856625&rtpof=true&sd=true",
  linkedin: "https://www.linkedin.com/in/vidhyasagar-go",
  twitter: "https://twitter.com/vidhyasagar",
  insta: "https://www.instagram.com/vidhya_sagar_reddy_?igsh=MXFjeHdtbDB4ZHg3dg%3D%3D&utm_source=qr ",
  facebook: "https://www.facebook.com/vidhyasagar",
};

export const skills = [
  {
    title: "Cloud & Infrastructure",
    skills: [
      {
    name: "AWS",
    image: "https://icon2.cleanpng.com/20190418/vhc/kisspng-amazon-web-services-logo-cloud-computing-amazon-co-logoaws-1-itnext-summit-1713897597915.webp",
  },
  {
    name: "Hetzner",
    image: "https://www.svgrepo.com/show/331425/hetzner.svg",
  },
  {
    name: "Terraform",
    image: "https://cdn.iconscout.com/icon/premium/png-256-thumb/terraform-11797001-9632800.png",
  },
  {
    name: "Kubernetes",
    image: "https://upload.wikimedia.org/wikipedia/commons/3/39/Kubernetes_logo_without_workmark.svg",
  },
  {
    name: "Docker",
    image: "https://www.docker.com/wp-content/uploads/2022/03/Moby-logo.png",
  },
  {
    name: "Linux",
    image: "https://upload.wikimedia.org/wikipedia/commons/3/35/Tux.svg",
  },
  {
    name: "Nginx",
    image: "https://upload.wikimedia.org/wikipedia/commons/c/c5/Nginx_logo.svg",
  },
    ],
  },
  {
    title: "CI/CD & Automation",
    skills: [
      {
    name: "Jenkins",
    image: "https://www.jenkins.io/images/logos/jenkins/jenkins.svg",
  },
  {
    name: "GitHub Actions",
    image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
  },
  {
    name: "GitLab CI",
    image: "https://about.gitlab.com/images/press/logo/png/gitlab-icon-rgb.png",
  },
  {
    name: "Ansible",
    image: "https://raw.githubusercontent.com/detain/svg-logos/b02ee1ac30c7ff4757278337c95588b01ed0954b/svg/a/ansible.svg",
  },
  {
    name: "Bash Scripting",
    image: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Bash_Logo_Colored.svg",
  },
  {
    name: "Python",
    image: "https://www.python.org/static/community_logos/python-logo.png",
  },

    ],
  },
  {
    title: "Monitoring & Security",
    skills: [
      {
    name: "Zabbix",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Zabbix_logo_square.svg/1200px-Zabbix_logo_square.svg.png?20210705092339 2x",
  },
  {
    name: "Prometheus",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/2066px-Prometheus_software_logo.svg.png",
  },
  {
    name: "Grafana",
    image: "https://gimgs2.nohat.cc/thumb/f/640/grafana-prometheus-grafana-logo--m2H7d3Z5Z5b1G6Z5.jpg",
  },
  {
    name: "CloudWatch",
    image: "https://w7.pngwing.com/pngs/246/10/png-transparent-aws-cloudwatch-hd-logo.png",
  },
  {
    name: "System Hardening",
    image: "https://sakesh.com.np/wp-content/uploads/2023/06/system-hardening.jpg", // generic lock icon
  },
  {
    name: "Security Audits",
    image: "https://sysaudits.com/wp-content/themes/sysaudits/images/Sys_logo.png;?>", // generic audit icon (search)
  },
  {
    name: "Backup & Disaster Recovery",
    image: "https://st4.depositphotos.com/18664664/23992/v/450/depositphotos_239923716-stock-illustration-relational-database-management-system-icon.jpg",
  },
    ],
  },
  {
    title: "Tools & DevOps Stack",
    skills: [
      {
        name: "Git",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2wZKbfqVXhy37hyh7dK1KxufUoQa5pXaZS2BCue_fo_PSV9iYRMYo3G8eI8n_IzGmpQo&usqp=CAU",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
       {
    name: "ELK Stack",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQ_EeBBMpmmaplmZ-pMVJ6K0bTMCKx3JduMQ&s",
  },
  {
    name: "Apache Maven",
    image: "https://maven.apache.org/images/maven-logo-black-on-white.png",
  },
  {
    name: "Samba AD",
    image: "https://www.citypng.com/public/uploads/preview/microsoft-active-directory-windows-server-logo-hd-png-701751694708071w7ncscp1gn.png",
  },
  {
    name: "PostgreSQL",
    image: "https://upload.wikimedia.org/wikipedia/commons/2/29/Postgresql_elephant.svg",
  },
  {
    name: "MySQL",
    image: "https://upload.wikimedia.org/wikipedia/en/d/dd/MySQL_logo.svg",
  }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://pbs.twimg.com/profile_images/1752232706585559040/mTIa9BLZ_400x400.jpg",
    role: "Senior Linux System Admin",
    company: "Visys Cloud Technologies.",
    date: "July 2023 - Present",
    desc: "Visys Cloud Technologies is a leading provider of cloud infrastructure and DevOps automation solutions, empowering businesses with scalable, secure, and high-performance systems. We also power innovative platforms like AI4Bazzar, an AI-driven marketplace, and Cloud4CoolKids, an edtech initiative nurturing young innovators through interactive learning.",
    skills: [
        "Docker",
        "Kubernetes",
        "Terraform",
        "AWS",
        "Jenkins",
        "Prometheus",
        "CloudWatch",
        "ELK Stack",
        "Python",
        "CI/CD"
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRboSwk2FMNWF7ppCYW0DwqxOxx1RI-Fqgl6A&s",
    role: "Associate Engineer (System Administrator) ",
    company: "Pennant Technologies ",
    date: "Jan 2021 - July 2023",
    desc: "Handled Linux and Windows Server administration, LDAP, Samba AD, and database management. Automated workflows and maintained system security and uptime. Collaborated on deploying and supporting critical infrastructure for banking clients. **Banking Domain** Ensured IT systems met stringent security and compliance standards. Focused on delivering reliable, high-availability solutions to support financial operations and customer services.",
    skills: [
      "Linux",
      "LDAP",
      "Samba AD",
      "MySQL",
      "PostgreSQL",
      "Shell Scripting",
      "Nginx",
      "Zabbix",
      "Firewall",
      "Windows Server"
    ],
   // doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/C560BAQHXjqxb_9zVXA/company-logo_200_200/company-logo_200_200/0/1630661328564/infiniti_techlabs_llp_logo?e=2147483647&v=beta&t=31uXaQ7dUZ5h8psW1J-LjvucQtCzbl6puWsxP8wr-ck",
    role: "Linux Administrator",
    company: "Infinite Tec labs",
    date: "July 2010 - Jan 2021",
    desc: "Worked on managing Linux servers, automating infrastructure tasks, and supporting deployment pipelines. Contributed to system performance tuning, network configuration, and security hardening across on-prem and cloud environments. Gained hands-on experience with tools like Apache, Nginx, and Bash scripting.",
    skills: [
      "CentOS",
      "Yum",
      "RPM",
      "NFS",
      "Apache",
      "User Management",
      "System Monitoring",
      "Backup",
      "Troubleshooting"
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbg7OOiLOsOnOxkAKd0OrrjdEBGj5F96tAs55PlrftpKQTU8_6jlc-IaUNy8eD7GS_pmc&usqp=CAU",
    school: "Saint Peters University",
    date: "Sep 2023 - May 2025",
    grade: "3.9/4 GPA",
    desc: "Located in Jersey City, New Jersey, Saint Peter’s University offers a rigorous graduate program emphasizing hands-on learning, research, and real-world application. The curriculum focuses on advanced computing concepts, data analysis, cloud technologies, and problem-solving strategies to prepare students for dynamic tech careers. Engaged in projects and coursework that enhanced technical expertise, critical thinking, and professional development.",
    degree: "Master of Science (MS) in Data Science",
  },
  {
    id: 1,
    img: "https://seekvectors.com/files/download/lpu-logo-01.jpg",
    school: "Lovely Professional University",
    date: "2015 - 2019",
    grade: "3.2/4 GPA",
    desc: "Gained strong foundational knowledge in electronic circuits, communication systems, digital signal processing, and embedded systems. Worked on practical lab-based projects involving microcontrollers, antennas, and VLSI design. Built programming skills in C and Python, with exposure to networking and system-level design. Developed an understanding of both hardware and software aspects of communication technology.",
    degree: "Bachelor of Technology (B.Tech), Electronic and communication ",
  },
];

export const projects = [
  {
    id: 9,
    title: "Treatment of Industrial Effluents (IoT)",
    date: " Granted - 2019 IPR No: 201811016398",
    description:
      "Designed and developed a platform-independent, cloud-based IoT architecture for the real-time monitoring and treatment of industrial effluents. The system enables cost-effective, smart, and secure management of effluent treatment plants using loosely coupled components. Leveraged Python and Raspberry Pi to implement sensor communication and data processing logic on a Linux-based environment, ensuring portability, scalability, and automation in industrial applications.",
    image:
      "/images/LPU.jpg",
    tags: [
      "AWS",
      "CI/CD",
      "React Js",
      "Node Js",
      "IOT",
      "Linux",
      "Python"
    ],
    /* category: "web app",
    github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://trackify.duckdns.org", */
  },
  /* {
    id: 0,
    title: "Podstream",
    date: "Apr 2023 - May 2023",
    description:
      "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
    image:
      "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    github: "https://github.com/rishavchanda/Podstream",
    webapp: "https://podstream.netlify.app/",
    member: [
      {
        name: "Rishav Chanda",
        img: "https://avatars.githubusercontent.com/u/64485885?v=4",
        linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },
  {
    id: 1,
    title: "Vexa",
    date: "Oct 2022 - Present",
    description:
      "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
    image:
      "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github: "https://github.com/rishavchanda/Project-Management-App",
    webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "Brain Tumor Detection",
    date: "Jan 2023 - Mar 2023",
    description:
      "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    image:
      "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    webapp: "https://brain-tumor.netlify.app/",
    member: [
      {
        name: "Rishav Chanda",
        img: "https://avatars.githubusercontent.com/u/64485885?v=4",
        linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },
  {
    id: 3,
    title: "Buckoid",
    date: "Dec 2021 - Apr 2022",
    description:
      "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
    image:
      "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
    tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    category: "android app",
    github: "https://github.com/rishavchanda/Buckoid-Android-App",
    webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 10,
    title: "Job Finding App",
    date: "Jun 2023 - Jul 2023",
    description:
      "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
    image:
      "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
    tags: ["React Native", "JavaScript", "Axios"],
    category: "android app",
    github: "https://github.com/rishavchanda/Job-finder-App",
    webapp: "https://github.com/rishavchanda/Job-finder-App",
  },
  {
    id: 4,
    title: "Whatsapp Clone",
    date: "Jul 2021",
    description:
      "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    webapp: "https://whatsapp-clone-rishav.web.app",
  },
  {
    id: 5,
    title: "Todo Web App",
    date: "Jun 2021",
    description:
      " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Todo-Web-App",
    webapp: "https://rishav-react-todo.netlify.app/",
  },
  {
    id: 6,
    title: "Breaking Bad",
    date: "Jun 2021",
    description:
      "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
    image:
      "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
    tags: ["React Js", "API", "Axios", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Breaking-Bad",
    webapp: "https://breaking-bad-webapp.netlify.app",
  },
  {
    id: 7,
    title: "Quiz App",
    date: "Dec 2020 - Jan 2021",
    description:
      "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    category: "android app",
    github: "https://github.com/rishavchanda/Quiz-Earn",
    webapp: "https://github.com/rishavchanda/Quiz-Earn",
  },
  {
    id: 8,
    title: "Face Recognition",
    date: "Jan 2021",
    description:
      "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    image:
      "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  }, */
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
